<template lang="pug">
v-card(flat).d-flex.flex-column.overflow-auto.scroll.fill-height.pa-2
  .mb-3
    v-list-item(style="min-height: 0px")
      v-list-item-content.pb-0.align-self-start
        .text-body-1.mr-2.grey--text.text--darken-1 № {{ item.number }}
        //- div
        //-   v-chip( label
        //-     v-if="item.is_active"
        //-     :color="item.is_concluded ? 'success' : 'error'" small
        //-   ) {{item.is_concluded ? 'Активен' : 'Не активен'}}
        //-   v-chip(
        //-     v-else
        //-     small color="error"
        //-   ) Аннулирован
        //- .d-flex.text-body-1.align-center
        //-   v-chip(
        //-     label small outlined
        //-     :color="statusData.color"
        //-   )
        //-     v-icon(left small) {{ statusData.icon }}
        //-     span {{ statusData.text }}

      v-list-item-icon.mx-0.mb-0.mt-2
        v-menu(
          bottom offset-y
        )
          template(#activator="{ on }")
            v-btn(icon depressed color="secondary" v-on="on"): v-icon mdi-menu
          v-list(color="secondary lighten-1" dark)
            v-list-item(
              v-if="item.preview_document"
              @click="openPreviewDocument"
            )
              v-list-item-action.mr-4: v-icon mdi-file-eye
              v-list-item-content.text-body-2: strong Открыть договор

            v-list-item(
              @click="openHistory"
            )
              v-list-item-action.mr-4: v-icon mdi-history
              v-list-item-content.text-body-2: strong История операции

            v-list-item(
              v-if="isEnrollment && !item.is_concluded"
              @click="openCreateContractModal"
            )
              v-list-item-action.mr-4: v-icon(color="error") mdi-file-document-edit-outline
              v-list-item-content.error--text.text-body-2: strong Внести изменения в договор

            v-list-item(
              v-if="check"
              @click="openConfirmCancel"
            )
              v-list-item-action.mr-4: v-icon(color="error") mdi-cancel
              v-list-item-content.error--text.text-body-2: strong Аннулировать

  v-card-text.py-0
    v-list.pt-0.mb-3
      v-list-item.px-0(v-if="isEnrollment && organization")
        v-list-item-avatar.mr-3(color="secondary")
          v-icon(color="white" size="24" style="padding-bottom: 3px") mdi-town-hall
        v-list-item-content.text-body-2
          .text-body-2 Исполнитель
          strong {{ organization.short_name }}
        v-list-item-action
          v-badge(dot :value="item.chat.exists_unread_messages" color="error")
            v-btn(icon depressed color="secondary" @click="openChat")
              v-icon mdi-chat
      v-skeleton-loader(
        v-else-if="isEnrollment && !organization"
        type="list-item-avatar"
      )
      v-list-item.px-0(v-else)
        v-list-item-avatar.mr-3(color="primary" size="34")
          v-icon(color="white" size="24" ) mdi-account
        v-list-item-content.text-body-2
          .text-body-2 Заказчик
          strong {{ item.owner.full_name }}
        v-list-item-action
          v-badge(dot :value="item.chat.exists_unread_messages" color="error")
            v-btn(icon depressed color="secondary" @click="openChat")
              v-icon mdi-chat
    .mb-4(
      v-if="item.users.length > 1"
    )
      .text-body-2 Слушатели:
      v-list-item.pl-2.mx-n2.pr-0(
        @click="openListeners"
      )
        v-list-item-icon.mr-4: v-icon(color="secondary" size="28") mdi-account-group
        v-list-item-content.text-body-2: strong Посмотреть список
        v-list-item-icon.mr-4: v-icon(color="secondary") mdi-eye
    .mb-2(
      v-else-if="!userIsOwner"
    )
      .text-body-2 Слушатель:
      v-list-item.pl-2.mx-n2.pr-0
        v-list-item-icon.mr-4: v-icon(color="secondary" size="28") mdi-account
        v-list-item-content.text-body-2: strong {{ item.users[0].full_name }}

    .text-body-2(
      v-if="(!userIsOwner ? true : item.document) || item.act || isEndLearning"
    ) Соглашения:
    sign-contract-panel(
      v-if="!userIsOwner"
      :contract="item"
      :document="item.document"
      :name="`Договор № ${item.number}`"
      :isSignedCustomer="item.is_signed_customer"
      :isSignedExecutor="item.is_signed_executor"
      :isEnrollment="isEnrollment"
      :isCustomerSignFirst="true"
      :getSignMethod="$api.contracts.getSignDocumentsContract"
      :signMethod="$api.contracts.signDocument"
      :getPrintMethod="$api.contracts.getPrintVersionContract"
      @set="updateContractLocale"
    )

    v-list-item.mx-n2.px-2(
      v-else-if="item.document"
      target="_blank"
      :href="item.document.url"
    )
      v-list-item-icon.mr-4: v-icon(
        size="32"
        color="secondary"
      ) mdi-file-download
      v-list-item-content
        .secondary--text.text-body-2: strong Скачать договор
    sign-contract-panel.mb-3(
      v-if="item.act || isEndLearning"
      :contract="item"
      :showCreate="!item.act && isEndLearning"
      name="Акт к договору"
      noPrint
      :document="item.act"
      :isSignedCustomer="item.is_signed_customer_act"
      :isSignedExecutor="item.is_signed_executor_act"
      signKey="_act"
      :isEnrollment="isEnrollment"
      :signMethod="$api.contracts.signAct"
      :getSignMethod="$api.contracts.getSignDocumentsAct"
      :getPrintMethod="$api.contracts.getPrintVersionAct"
      @set="updateContractLocale"
      @update="$emit('update', item.id)"
    )

    v-sheet.grey.lighten-4.sdo-radius.pa-4.mb-4
      .text-body-2 Оплачено:
      v-progress-linear.mt-2.mb-6(
        :value="item.paymentPercent" height="30" color="secondary darken-1" rounded striped
      )
        .white--text.text-body-2.font-weight-medium
          | {{ item.payment.toFixed(2) }} ₽ из {{ +item.sum_total }} ₽
      .mb-4(v-if="enrollment && +item.sum_total.split('.')[0] !== item.prePaymentValue")
        .text-body-2 Стоимость обучения:
        v-list-item.px-0(:disabled="item.isAllPayed")
          v-list-item-content
            .text-md-h3.mb-2.text-h4: strong {{item.sum_total.split('.')[0]}} ₽
            div
              v-chip(
                label small
                :color="item.isAllPayed ? 'success' : ''"
              )
                strong(v-if="item.isAllPayed") Оплачено
                strong(v-else) внести до {{ item.getDays(enrollment, 'end_learning') }}
          v-list-item-avatar.mt-0.mr-1(
            v-if="item.isAllPayed"
            color="success" size="28"
          )
            v-icon(color="white" small) mdi-check-bold

      div(v-if="enrollment")
        .text-body-2.
          {{+item.sum_total === item.prePaymentValue ? 'Стоимость обучения:' : 'Предоплата:'}}
        v-list-item.px-0(
          :disabled="item.isPaymentPrePayment"
        )
          v-list-item-content.pt-2
            .text-md-h3.mb-2.text-h4: strong {{ item.prePaymentValue }} ₽
            div
              v-chip(
                label small
                :color="item.isPaymentPrePayment ? 'success' : ''"
              )
                strong(v-if="item.isPaymentPrePayment") Оплачено
                strong(v-else) внести до {{ item.getDays(enrollment, 'period_end') }}

          v-list-item-avatar.mt-0.mr-1(
            v-if="item.isPaymentPrePayment"
            color="success" size="28"
          )
            v-icon(color="white" small) mdi-check-bold
      template(v-if="!enrollment")
        v-skeleton-loader(
          type="article, article"
        )

    //- v-btn.mb-4(
    //-   v-if="!isEnrollment && !item.typical_contract_discount"
    //-   color="secondary lighten-1"
    //-   small block text
    //-   @click="item.openDiscountModal()"
    //- ) Установить скидку

  v-card-actions.mt-auto
    template(v-if="isEnrollment && !item.isAllPayed")
      v-btn.ml-auto(
        v-if="$user.isOrganization || $user.isOperator || $user.isDepartment"
        color="success" depressed block large
        @click="item.openPaymentPDF(payment)"
      ) Счет на оплату
      v-btn.ml-auto(
        v-else
        color="success" block large
        @click="item.openPaymentModal(isEnrollment)"
      )  Сформировать квитанцию на оплату
    v-btn.ml-auto(
      v-else-if="!isEnrollment"
      color="primary" block large
      @click="openSetPayment"
    ) Внести поступления по договору
  .text-body-2.text-center.grey--text(
    v-if="isEnrollment && !item.isAllPayed"
  ) Внести:
    |  {{ !item.isPaymentPrePayment ? item.prePaymentValue : item.maxPayment }} ₽

  portal(to="history.dialog" v-slot="{ close, attrs }")
    v-card(max-height="400").overflow-auto.scroll.sdo-card
      v-card-title.text-body-1.mb-4: strong История операции:
      v-card-text
        v-alert(
          v-if="item.transactions && !item.transactions.length"
          type="info" outlined
        ) Не совершено ни одной транзакции

        v-col.pa-0.mb-4(
          v-for="tran in item.transactions" :key="tran.id"
        )
          v-row(nu-gutters)
            v-col
              v-list-item-subtitle.text-body-2 {{ paymentAt(tran) }}
              v-list-item-title.text-body-2(
                :class=" tran.sum > 0 ? 'success--text' : 'error--text'"
              ): strong {{tran.sum > 0 ? 'Пополнение:' : 'Возврат'}}
            v-col.align-self-end
              div(:class=" tran.sum > 0 ? 'success--text' : 'error--text'").text-end
                strong {{ tran.sum }} руб.
          v-divider

  portal(to="listeners.dialog" v-slot="{ close, attrs }")
    v-card(max-height="400").overflow-auto.scroll.sdo-card
      v-card-title.text-body-1.mb-4: strong Список слушателей:
      v-card-text
        v-list
          v-list-item.px-2(
            v-for="user in item.users" :key="user.id"
          )
            v-list-item-avatar(color="secondary")
              v-icon(color="white") mdi-account
            v-list-item-content.text-body-2
              strong {{user.full_name}}

</template>

<script>
import { format, parseISO } from 'date-fns';
import CreateContractModal from '@/components/Enrollment/CreateContractModal.vue';
import EnrollmentElementFilters from '@/modules/CourseManagement/components/Enrollment/EnrollmentElementFilters.vue';
import EnrollmentElementUser from '@/modules/CourseManagement/components/Enrollment//EnrollmentElementUser.vue';
import PreviewContract from './PreviewContract.vue';
import SignContractPanel from './SignContractPanel.vue';
import SetPaymentModal from './SetPaymentModal.vue';

export default {
  components: {
    EnrollmentElementFilters,
    EnrollmentElementUser,
    SignContractPanel,
  },
  props: {
    isEnrollment: { type: Boolean, default: false },
    item: { type: Object, default: null },
  },
  data() {
    return {
      enrollment: null,
      loading: true,
      course: null,
      organization: null,
      panel: 2,
      changeSumMode: false,
      format,
      parseISO,
    };
  },
  computed: {
    statusData() {
      const { item } = this;
      const activeColor = item.is_active ? 'grey' : 'error';
      const activeText = item.is_active ? 'Не заключен' : 'Аннулирован';
      const activeIcon = item.is_active ? 'mdi-clock-time-four-outline' : 'mdi-close';
      return {
        color: item.is_concluded ? 'success' : activeColor,
        text: item.is_concluded ? 'Заключен' : activeText,
        icon: item.is_concluded ? 'mdi-check' : activeIcon,
      };
    },
    isMobile() {
      return this.$vuetify.breakpoint.mobile;
    },
    userIsOwner() {
      const { owner_id: ownerId, users: [{ id }] } = this.item;
      return ownerId === id;
    },
    check() {
      const { item } = this;
      return item.is_active && (item.paymentPercent <= 0);
    },
    isEndLearning() {
      if (this.enrollment) {
        const end = new Date(this.enrollment.end_learning).getTime();
        const now = new Date().getTime();
        return end < now;
      }
      return false;
    },
  },
  async created() {
    this.loading = true;
    const resp = await this.$api.enrollments.getEnrollment(
      this.item.prior_record_id,
    );
    this.enrollment = resp.data.data;

    const { item } = await this.$api.courses.show(
      this.enrollment.course_id, { expand: 'organization' },
      this.$conf.COURSE_SERVICE.student,
    );
    const { id } = item.organization;

    const { data } = await this.$api.contacts.getInfo(id);
    this.organization = data.data;
    this.loading = false;
  },
  mounted() {
    if (this.$route.query.payment) this.item.openPaymentModal(this.isEnrollment);
    this.item.getPreviewDocument();
  },
  methods: {
    openHistory() {
      this.$modals.show('dialog-portal', {
        inputValue: 'history',
      });
    },
    openListeners() {
      this.$modals.show('dialog-portal', {
        inputValue: 'listeners',
      });
    },
    openConfirmCancel() {
      const message = this.userIsOwner
        ? `<p>Вы можете отказаться от заключения договора до внесения оплаты
          по нему (оплата по договору приравнивается к его подписанию).
          После аннулирования договора вы не сможете подать заявку на обучение в рамках текущего набора,
          но сможете позднее выбрать другой набор для обучения.</p>

          <p class="error--text>Вы точно хотите аннулировать договор?</p>`
        : `<p>Вы можете аннулировать заключение договора до его окончательного подписания.
          При этом сам договор будет считаться незаключенным, все обязательства по нему будут отменены.</p>

          <p>Если были внесены средства на оплату договора - пожалуйста, оговаривайте возврат с другой стороной.
          При аннулировании договора обучающиеся будут отчислены из набора без возможности восстановления
          (но вы сможете заключить договор на их обучение в следующем наборе).</p>

          <p class="error--text">Вы точно хотите аннулировать договор?</p>`;
      this.$modals.show('confirm-controller', {
        type: 'error',
        title: 'Подтвердите действие',
        message,
        method: async () => {
          await this.$api.contracts.cancelContract(this.item.id);
          this.$modals.close();
          this.$emit('unSelect');
        },
      });
    },
    openCreateContractModal() {
      this.$modals.show('confirm-controller', {
        type: 'error',
        title: 'Подтвердите действие',
        message: 'Если вы обнаружили неточности во внесенных вами при подаче заявки сведениях, вы можете изменить их до момента подписания договора со стороны исполнителя. Подтвердите намерение переформировать текст договора.  Обратите внимание, изменить состав обучающихся по договору не получится, лучше в этом случае подайте новую заявку на обучение',
        method: async () => {
          await new Promise((resolve) => setTimeout(() => {
            this.$modals.close();
            this.successOpen();
            resolve();
          }, 100));
          this.$nextTick(() => this.successOpen());
        },
      });
    },
    successOpen() {
      this.$modals.show('generic-controller', {
        title: 'Внесение изменений в текст договора',
        component: CreateContractModal,
        dialogProps: {
          persistent: true,
          width: 1000,
        },
        'component-props': {
          organizationId: this.item.typical_contract.owner_id,
          noStep: this.userIsOwner,
          employees: this.item.users,
          initContract: this.item,
          successCallback: (id) => {
            this.$modals.close();
            this.$emit('update', id);
          },
        },
      });
    },
    // async concludeContract() {
    //   const payload = {
    //     id: this.item.id,
    //     is_conclude: true,
    //   };
    //   this.$rHandler(
    //     this.$api.contracts.updateContracts(payload),
    //     () => {
    //       this.updateContractLocale({ ...this.item, is_conclude: true });
    //     },
    //   );
    // },
    updateContractLocale(value) {
      this.$set(this, 'contract', value);
    },
    async openChat() {
      this.item.chat.open({
        title: 'Чат по договору:',
        subtitle: this.item.number,
      });
    },
    paymentAt(item) {
      return format(new Date(item.created_at), 'dd.MM.yyyy');
    },
    openSetPayment() {
      this.$modals.show('generic-controller', {
        component: SetPaymentModal,
        title: 'Внести поступления по договору',
        dialogProps: {
          width: 600,
        },
        'component-props': {
          contract: this.item,
        },
      });
    },
    openPreviewDocument() {
      this.$modals.show('generic-controller', {
        component: PreviewContract,
        title: 'Предпросмотр',
        dialogProps: {
          width: 800,
        },
        'component-props': {
          previewDocument: this.item.preview_document,
        },
      });
    },
  },
};
</script>
